//#region
import { useState, useEffect } from 'react';
//material
import { Grid, FormControl, InputLabel, Select , MenuItem, Checkbox, ListItemText,Switch,FormControlLabel,Button } from '@mui/material';
// component
import Controls from '../../controls/Controls';
import { useForm, Form } from "../../useForm";
import { getUserType } from '../../../config/services/usertype';
//#endregion

const initialFValues = {
  _id: 0,
}

export default function DataSourcePopup(props) {
  const { addOrEdit, recordForEdit, setOpenPopup } = props
  const [dataSourceSSL, setDataSourceSSL] = useState(false);
  const [dbType,setDbType] = useState('')
  const [selectedFile,setSelectedFile] = useState('')
  const [uploadFile,setUploadFile] = useState('')




  const handleKeyFileUpload = (event) => {
    let reader = new FileReader();
    setSelectedFile(event.target.files[0])
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e) => {
        setUploadFile({data:reader.result.split(',').pop(),fileName:event.target.files[0].name})
      };
  }

  console.log("upload File::",uploadFile)

  const handleDbSSLChange = (e) => {
    const { checked } = e.target;
    setDataSourceSSL(checked)
  }
  const handleDbType = (e) => {
    setDbType(e.target.value)
  }

  // useEffect(() => {
  //   setUserTypeValueInital(recordForEdit?.userType);
  // }, [recordForEdit])

  const validate = (fieldValues = values) => {
    let temp = { ...errors }
    // if ('roleName' in fieldValues) {
    //   temp.roleName = fieldValues.roleName ? "" : "This field is required."
    // }
    // if()

    console.log(fieldValues)
    
    setErrors({
      ...temp
    })
      
    if (fieldValues === values)
      return Object.values(temp).every(x => x === "")
  }

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm
  } = useForm(initialFValues, true, validate);

  const handleSubmit = e => {
    e.preventDefault()
    // validate()
    // if (validate()) {
    //   values.userType = [userTypeAccess];
    // }
      values.dbSSL = dataSourceSSL
      values.dbType = dbType
      if(uploadFile) values.bqKeyFileInfo = uploadFile
      addOrEdit(values, resetForm);
  }
  
  useEffect(() => {
    if (recordForEdit != null)
      setValues({
        ...recordForEdit
      })
      setDataSourceSSL(recordForEdit?.dbSSL)
      setDbType(recordForEdit?.dbType)
      if(recordForEdit?.bqKeyFileInfo) {
        setUploadFile(recordForEdit?.bqKeyFileInfo)
      }
      
  }, [recordForEdit, setValues])


  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6} style={{marginLeft:'10px'}}>
          <InputLabel style={{fontSize:'12px'}}>DB Type</InputLabel>
          <Select fullWidth 
          value={values.dbType || recordForEdit?.dbType}
          onChange={handleDbType}>
             <MenuItem value="mysql">
               MySql
             </MenuItem>
             <MenuItem value="postgres">
               Postgres
             </MenuItem>
             <MenuItem value="bigQuery">
               BigQuery
             </MenuItem>
             <MenuItem value="mongobi">
               MongoBI
             </MenuItem>
          </Select>
        </Grid>
        <Grid item xs={8}>
          <Controls.Input
            name="dbName"
            label="Database Name"
            value={values.dbName}
            onChange={handleInputChange}
            error={errors.dbName}
          />
        </Grid>        
      {
        dbType === 'bigQuery' &&
        <>
          <Grid item xs={8}>
            <Controls.Input
              name="projectId"
              label="Project ID"
              value={values.projectId}
              onChange={handleInputChange}
              error={errors.projectId}
            />
          </Grid>
          <Grid item xs={6} m={1}>
            <Button
                variant="contained"
                component="label"
                className="report_form_ui_btn cancel mr-2 mt-2"
                        >
                  Select File
                <input
                  type="file"
                  accept=".json"
                  hidden
                  onChange={handleKeyFileUpload}
                />
            </Button>
            <InputLabel style={{fontSize:'12px',marginTop: '10px'}}>{uploadFile?.fileName}</InputLabel>
          </Grid>
        </>
    }
    
      {

        dbType !== 'bigQuery' &&
        <>
        <Grid item xs={8}>
          <Controls.Input
            name="dbHost"
            label="Database Host"
            value={values.dbHost}
            onChange={handleInputChange}
            error={errors.dbHost}
          />
        </Grid>
        
        <Grid item xs={8}>
          <Controls.Input
            name="dbUser"
            label="Database User"
            value={values.dbUser}
            onChange={handleInputChange}
            error={errors.dbUser}
          />
        </Grid>
        <Grid item xs={8}>
          <Controls.Input
            name="dbPassword"
            label="Database Password"
            type="password"
            value={values.dbPassword}
            onChange={handleInputChange}
            error={errors.dbPassword}
          />
        </Grid>
        <Grid item xs={8}>
          <Controls.Input
            name="dbPort"
            label="Database Port"
            value={values.dbPort}
            onChange={handleInputChange}
            error={errors.dbPort}
          />
        </Grid> 
        <FormControlLabel
            className="text-plain"
            control={<Switch checked={dataSourceSSL}/>}
            label="SSL" 
            name="dbSSL"
            onChange={handleDbSSLChange}
        />
        </>
      }
        <Grid item xs={8}>
          <div>
            <Controls.Button
              type="submit"
              text="submit"
            />
            <Controls.Button
              color="secondary"
              text="Cancel"
              onClick={e => setOpenPopup(false)}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  )
}
